import { Box, Flex, Text } from "@chakra-ui/react";
import AvatarGlyph from "../../common/AvatarGlyph";

export function DrawerAccountAvatar({
  initials,
  badge,
  badgeColor = "#EA580C",
}: {
  initials: string;
  badge?: number;
  badgeColor?: string;
}) {
  return (
    <Box position="relative" flexShrink={0}>
      <Flex
        w="2.55rem"
        h="2.55rem"
        rounded="full"
        bg="#16A34A"
        align="center"
        justify="center"
        border="2.5px solid white"
        boxShadow="0 0 0 2px rgba(34,197,94,0.22), 0 4px 14px rgba(22,163,74,0.18)"
      >
        <Text
          fontSize="0.88rem"
          fontWeight="800"
          color="white"
          letterSpacing="0.04em"
          lineHeight="1"
          userSelect="none"
        >
          <AvatarGlyph initials={initials} />
        </Text>
      </Flex>
      {badge != null && badge > 0 && (
        <Box
          position="absolute"
          top="-0.2rem"
          right="-0.2rem"
          w="1.1rem"
          h="1.1rem"
          rounded="full"
          bg={badgeColor}
          color="white"
          display="flex"
          alignItems="center"
          justifyContent="center"
          fontSize="0.55rem"
          fontWeight="900"
          lineHeight="1"
          border="1.5px solid white"
        >
          {badge}
        </Box>
      )}
    </Box>
  );
}
